var React = require('react');

function StarFilled (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M31.9 1.2l8.9 17.7L58 20.6c.4 0 .8.2 1.1.4s.6.6.7 1 .2.8.1 1.2-.3.8-.6 1.1l-14.1 14 5.2 19c.1.4.1.8 0 1.2s-.4.7-.7 1-.7.4-1.1.5c-.4 0-.8 0-1.2-.2L30 51.1l-17.4 8.6c-.4.2-.8.3-1.2.2-.4 0-.8-.2-1.1-.5s-.6-.6-.7-1-.1-.8 0-1.2l5.2-19-14.1-14c-.3-.3-.5-.7-.6-1.1-.1-.3-.1-.8 0-1.1.1-.4.4-.7.7-1 .3-.2.7-.4 1.1-.4l17.2-1.7L28 1.2a2.36 2.36 0 0 1 .8-.9c.4-.2.8-.3 1.2-.3s.8.1 1.1.3c.4.2.7.5.8.9z"}));
}

StarFilled.defaultProps = {"baseProfile":"tiny","viewBox":"0 0 60 60","overflow":"visible"};

module.exports = StarFilled;

StarFilled.default = StarFilled;
